import * as Types from '@crimeos-frontend/crime-os/graphql';

import { gql } from '@apollo/client';
export type GeneratedFieldResponseFragment = { __typename: 'GeneratedFieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null };

export type Crime_Os_Common_FieldResponseFragment = { __typename: 'FieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null };

export type Crime_Os_Common_FieldResponseType_BaseUser_Fragment = { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null };

export type Crime_Os_Common_FieldResponseType_GqlDateTimeType_Fragment = { __typename: 'GQLDateTimeType', dateTime?: string | null };

export type Crime_Os_Common_FieldResponseType_GqlDateType_Fragment = { __typename: 'GQLDateType', dateValue?: string | null };

export type Crime_Os_Common_FieldResponseType_GqlFloatType_Fragment = { __typename: 'GQLFloatType', floatValue?: number | null };

export type Crime_Os_Common_FieldResponseType_GqlIntType_Fragment = { __typename: 'GQLIntType', integerValue?: number | null };

export type Crime_Os_Common_FieldResponseType_GqlListStringType_Fragment = { __typename: 'GQLListStringType', values: Array<string> };

export type Crime_Os_Common_FieldResponseType_GqlStringType_Fragment = { __typename: 'GQLStringType', stringValue?: string | null };

export type Crime_Os_Common_FieldResponseType_GqlTimeType_Fragment = { __typename: 'GQLTimeType', timeValue?: string | null };

export type Crime_Os_Common_FieldResponseType_LookupResponseType_Fragment = { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> };

export type Crime_Os_Common_FieldResponseType_PhoneNumberResponse_Fragment = { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string };

export type Crime_Os_Common_FieldResponseType_Status_Fragment = { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number };

export type Crime_Os_Common_FieldResponseTypeFragment = Crime_Os_Common_FieldResponseType_BaseUser_Fragment | Crime_Os_Common_FieldResponseType_GqlDateTimeType_Fragment | Crime_Os_Common_FieldResponseType_GqlDateType_Fragment | Crime_Os_Common_FieldResponseType_GqlFloatType_Fragment | Crime_Os_Common_FieldResponseType_GqlIntType_Fragment | Crime_Os_Common_FieldResponseType_GqlListStringType_Fragment | Crime_Os_Common_FieldResponseType_GqlStringType_Fragment | Crime_Os_Common_FieldResponseType_GqlTimeType_Fragment | Crime_Os_Common_FieldResponseType_LookupResponseType_Fragment | Crime_Os_Common_FieldResponseType_PhoneNumberResponse_Fragment | Crime_Os_Common_FieldResponseType_Status_Fragment;

export type StatusFragment = { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number };

export type FieldResponseResult_FieldIsDeleted_Fragment = { __typename: 'FieldIsDeleted', message?: string | null };

export type FieldResponseResult_FieldIsNotCreated_Fragment = { __typename: 'FieldIsNotCreated', message?: string | null };

export type FieldResponseResult_FieldNotFound_Fragment = { __typename: 'FieldNotFound', message?: string | null };

export type FieldResponseResult_FieldResponse_Fragment = { __typename: 'FieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null };

export type FieldResponseResult_NotPermittedField_Fragment = { __typename: 'NotPermittedField', message?: string | null };

export type FieldResponseResultFragment = FieldResponseResult_FieldIsDeleted_Fragment | FieldResponseResult_FieldIsNotCreated_Fragment | FieldResponseResult_FieldNotFound_Fragment | FieldResponseResult_FieldResponse_Fragment | FieldResponseResult_NotPermittedField_Fragment;

export type Crime_Os_UpdateFieldResponseFragment = { __typename: 'FieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, generatedFieldResponses: Array<{ __typename: 'GeneratedFieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null }>, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null };

export const StatusFragmentDoc = gql`
    fragment Status on Status {
  statusId
  name
  color
  order
}
    `;
export const Crime_Os_Common_FieldResponseTypeFragmentDoc = gql`
    fragment Crime_Os_Common_FieldResponseType on FieldResponseType {
  ... on GQLStringType {
    stringValue: value
  }
  ... on GQLIntType {
    integerValue: value
  }
  ... on GQLFloatType {
    floatValue: value
  }
  ... on GQLListStringType {
    values: value
  }
  ... on GQLDateType {
    dateValue: value
  }
  ... on GQLTimeType {
    timeValue: value
  }
  ... on GQLDateTimeType {
    dateTime: value
  }
  ... on PhoneNumberResponse {
    dialCode
    iso2CountryCode
    phoneNumber
  }
  ... on Status {
    ...Status
  }
  ... on BaseUser {
    userId
    userName: name
    profilePicUrl
    email
  }
  ... on LookupResponseType {
    lookupResponses {
      label
      value
    }
  }
}
    ${StatusFragmentDoc}`;
export const Crime_Os_Common_FieldResponseFragmentDoc = gql`
    fragment Crime_Os_Common_FieldResponse on FieldResponse {
  fieldId
  fieldResponseId
  systemFieldEnum
  response {
    ...Crime_Os_Common_FieldResponseType
  }
}
    ${Crime_Os_Common_FieldResponseTypeFragmentDoc}`;
export const FieldResponseResultFragmentDoc = gql`
    fragment FieldResponseResult on FieldResponseResult {
  ... on FieldResponse {
    ...Crime_Os_Common_FieldResponse
  }
  ... on FieldNotFound {
    message
  }
  ... on NotPermittedField {
    message
  }
  ... on FieldIsDeleted {
    message
  }
  ... on FieldIsNotCreated {
    message
  }
}
    ${Crime_Os_Common_FieldResponseFragmentDoc}`;
export const GeneratedFieldResponseFragmentDoc = gql`
    fragment GeneratedFieldResponse on GeneratedFieldResponse {
  fieldId
  fieldResponseId
  systemFieldEnum
  response {
    ...Crime_Os_Common_FieldResponseType
  }
}
    ${Crime_Os_Common_FieldResponseTypeFragmentDoc}`;
export const Crime_Os_UpdateFieldResponseFragmentDoc = gql`
    fragment Crime_Os_UpdateFieldResponse on FieldResponse {
  fieldId
  fieldResponseId
  systemFieldEnum
  generatedFieldResponses {
    ...GeneratedFieldResponse
  }
  response {
    ...Crime_Os_Common_FieldResponseType
  }
}
    ${GeneratedFieldResponseFragmentDoc}
${Crime_Os_Common_FieldResponseTypeFragmentDoc}`;